import "./RL1SlipSetupStyle.css";

import * as yup from "yup";

import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedDropDownRHFWithLabel,
	EnhancedSnackbar,
	IEnhancedDropDownItem,
	IResponse,
	IServerError,
	ITest,
	LabelPosition,
	StandardPanel,
	TwoColumnLayout,
} from "@websential/cosmic-v20";
import { Button, Grid, useTheme } from "@mui/material";
import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import {
	GET_QUERY_KEY,
	INITIAL_SNACKBAR_DATA,
	QUERY_OPTIONS,
	RL1_SETUP_SCREEN_SLUG,
} from "../../../common/constants";
import { findEmployeeOrSlip, scrollPanelFieldsToTop, sortDDLByLabel, useNavigateToLogout } from "../../../common/Common";
import {
	setSelectedActivityLogActions,
	setSelectedStickyNavBar,
} from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";

import { AuthService } from "../../../services";
import { CityService } from "../../../services/CityService";
import { CountryService } from "../../../services/common/CountryService";
import { EmployeeAddressSetupFieldsPanel } from "./Panels/EmployeeAddressSetupFieldsPanel";
import { EmployeeInfoSetupFieldsPanel } from "./Panels/EmployeeInfoSetupFieldsPanel";
import { EmployeeService } from "../../../services/EmployeeService";
import { EnhancedDialog } from "@websential/cosmic-v20";
import FileSaver from "file-saver";
import { FilingDataSetupFieldsPanel } from "./Panels/FilingDataSetupFieldsPanel";
import { FilteredSelectedOtherInfoRL1 } from "./Panels";
import { IAppState } from "../../../store/reducers";
import { IDropDownListResponse } from "../../../models/common/IDropDownListResponse";
import { IRL1SlipRequestPayload } from "../../../models/rl1Slip/IRL1SlipRequestPayload";
import { InvoiceDialogPanel } from "../../T4Slip/T4SlipList/InvoiceDialogPanel";
import { PrintingService } from "../../../services/PrintingService";
import { RL1OtherInformationService } from "../../OtherInformation/otherInformations";
import { RL1SlipService } from "../../../services/RL1SlipService";
import { RL1SlipSetupToolbar } from "./RL1SlipSetupToolbar";
import { RL1SlipSetupValidationSchema } from "./validator";
import { ReportsService } from "../../../services/ReportsService";
import { ResourceDDLDataTableForSlips } from "../../ResourceDDLDataTableForSlips";
import { T4SlipDataPanel } from "./Panels/T4SlipDataPanel";
import { T4SlipService } from "../../../services/T4SlipService";
import { TaxSlipSettingsService } from "../../../services/TaxSlipSettingsService";
import { format } from "date-fns";
import { instanceOfIRL1SlipResponce } from "../../../common/instance-method";
import { selectedRL1SummaryType } from "../RL1SlipSummarySetup";
import { setSelectedDrawerOptionsMenu } from "../../../store/actions/drawerMenuOptionsActions";
import { setSelectedINVOICE } from "../../../store/actions/invoiceReportActions";
import { setSelectedSlips } from "../../../store/actions/slipsActions";
import { yupResolver } from "@hookform/resolvers/yup";

export let selectedRL1SlipType: any = 400;
export interface IRL1SlipSetup extends ITest { }
const SINGLE_RECORD_DATA_QUERY_KEY = "rl1-slips-single-data-record";

const EMPLOYEE_DDL_DATA_QUERY_KEY = "employee-ddl-data-record";
const SINGLE_Employee_DATA_QUERY_KEY = "employee-data";
// const useGetData = (
// 	id: string | undefined,
// 	clientId: string,
// 	taxYear: number
// ) => {
// 	return useQuery({
// 		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, id],
// 		queryFn: () => RL1SlipService.getRL1SlipById(id, clientId, taxYear),
// 		refetchOnWindowFocus: false,
// 	});
// };

const useGetData = (
	employeeId: string | null,
	provinceOfEmploymentId: string | null,
	slipType: number,
	clientId: string,
	taxYear: number
) =>
	useQuery({
		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, employeeId, provinceOfEmploymentId, slipType, clientId, taxYear],
		queryFn: (data) => {
			return RL1SlipService.getRL1SlipByIdAndPoeIdAndSlipType(employeeId, provinceOfEmploymentId, slipType, clientId, taxYear);
		},
		refetchOnWindowFocus: false,
	});

// const useGetSlipRecord = (
// 	slipId: string,
// 	clientId: string,
// 	taxYear: number
// ) => {
// 	return useQuery({
// 		queryKey: [GET_QUERY_KEY.EMPLOYEE_RESOURCE_SLIP_DETAIL, slipId],
// 		queryFn: () => RL1SlipService.getById(slipId, clientId, taxYear),
// 		...QUERY_OPTIONS,
// 		enabled: false,
// 	});
// };

// const useGetResourceSlips = (
// 	resourceId: string,
// 	clientId: string,
// 	taxYear: number
// ) => {
// 	return useQuery({
// 		queryKey: [GET_QUERY_KEY.EMPLOYEE_RESOURCE_SLIPS_DDL, resourceId],
// 		queryFn: () =>
// 			RL1SlipService.getResourceSlipDropDownList(resourceId, clientId, taxYear),
// 		...QUERY_OPTIONS,
// 		enabled: false,
// 	});
// };

const useGetResourceInformationById = (
	resourceId: string,
	clientId: string,
	roleName: string
) => {
	return useQuery({
		queryKey: [SINGLE_Employee_DATA_QUERY_KEY, resourceId, clientId, roleName],
		queryFn: () =>
			RL1SlipService.getResourceInformationById(resourceId, clientId, roleName),
		refetchOnWindowFocus: false,
	});
};

// const useGetGlobalVariables = (taxYear: number) =>
// 	useQuery({
// 		queryKey: [GET_QUERY_KEY.GET_GLOBAL_VARIABLES_BY_YEAR, taxYear],
// 		queryFn: (data) => {
// 			return TaxSlipSettingsService.getGlobalVariables(taxYear);
// 		},
// 		refetchOnWindowFocus: false,
// 	});

// const useGetSlipIds = (tag: string, clientId: string, taxYear: number) =>
// 	useQuery({
// 		queryKey: ["get-slip-ids", tag, clientId, taxYear],
// 		queryFn: (data) => {
// 			return T4SlipService.getSlipIds(tag, clientId, taxYear);
// 		},
// 		refetchOnWindowFocus: false,
// 	});

// const useGetCompanyData = (
// 	id: string | undefined,
// 	navigateToLogout: (path: string) => void
// ) =>
// 	useQuery({
// 		queryKey: ["client-get-by-id", id],
// 		queryFn: (data) => {
// 			return ClientService.getById(id, navigateToLogout);
// 		},
// 		refetchOnWindowFocus: false,
// 	});

// const useGetCountryDDL = () =>
// 	useQuery({
// 		queryKey: ["country-ddl"],
// 		queryFn: (data) => {
// 			return CountryService.getCountryDDL();
// 		},
// 		refetchOnWindowFocus: false,
// 	});
const RL1_SUMMARY_DATA_QUERY_KEY = "get-rl1-summary-data";
const useGetRL1SummaryData = (
	clientid: string,
	slipType: string | number,
	taxYear: number
) =>
	useQuery({
		queryKey: [RL1_SUMMARY_DATA_QUERY_KEY],
		queryFn: (data) => {
			return RL1SlipService.getRL1Summary(clientid, slipType, taxYear);
		},
		refetchOnWindowFocus: false,
	});
const useGetEmployeeDDLItems = (clientId: string, taxYear: number) =>
	useQuery({
		queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId, taxYear],
		queryFn: (data) => {
			// return T4SlipService.getQCEmployeeDDL(clientId);
			return T4SlipService.getEmployeeDDLForRL1Slips(clientId, taxYear);
		},
		refetchOnWindowFocus: false,
	});
const useGetPayFrequencyDDL = (clientId: string, taxYear: number) =>
	useQuery({
		queryKey: ["pay-frequency-ddl"],
		queryFn: (data) => {
			return EmployeeService.getPayFrequencyDDL(clientId, taxYear);
		},
		refetchOnWindowFocus: false,
	});
const useGetMaskStatus = () =>
	useQuery({
		queryKey: ["mask-status"],
		queryFn: (data) => {
			return AuthService.getMaskStatus();
		},
		refetchOnWindowFocus: false,
	});
export const RL1SlipSetup: FC<IRL1SlipSetup> = ({ testId }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const navigateToLogout = useNavigateToLogout();
	const [snackbarData, setSnackbarData] = useState<any>(INITIAL_SNACKBAR_DATA);
	const clientId = useSelector((state: IAppState) => state.client.id);
	const clientName = useSelector((state: IAppState) => state.client.clientName);
	const canadaProvinces = useSelector(
		(state: IAppState) => state.countryAndProvincesInfo.canada
	);
	const countryList = useSelector(
		(state: IAppState) => state.countryAndProvincesInfo.countryDDL
	);
	const isPendingActivityLogData = useSelector(
		(state: IAppState) => state.isLoadAxiosCall.isLoading
	);
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const theme = useTheme();
	const [invoicePaymentFor, setInvoicePaymentFor] = useState(10);
	const [provinceDDLLoading, setProvinceDDLLoading] = useState(false);
	const [cityDDLinUpdate, setCityDDLinUpdate] = useState(undefined);

	const [provinceStateDDLinUpdate, setProvinceStateDDLinUpdate] =
		useState<any>(undefined);
	const [provinceDDLItems, setProvinceDDLItems] = useState(undefined);
	const [provinceStateLabelinUpdate, setProvinceStateLabelinUpdate] =
		useState<any>(undefined);

	const taxYear = useSelector((state: IAppState) => state.taxYear.year);
	const [isPendingSlipData, setIsPendingSlipData] = useState(false);
	const [selectedResource, setSelectedResource] = useState("create-new");
	const [selectedResourceSlip, setSelectedResourceSlip] =
		useState("create-new");

	const [onResourceSelectionAPIsCalls, setOnResourceSelectionAPIsCalls] =
		useState(false);
	const [selectedResourceSlipList, setSelectedResourceSlipList] = useState<
		IDropDownListResponse[]
	>([{ label: "Create New", value: "create-new" }]);
	const [openInvoiceDialog, setInvoiceDialogOpen] = useState(false);
	const [invoiceData, setInvoiceData] = useState<any>([]);
	const [isPendingDataa, setIsPendingData] = useState(false);
	const [resourceListWithoutCreateNew, setResourceListWithoutCreateNew] =
		useState<any>(undefined);
	const [provinceOfEmploymentId, setProvinceOfEmploymentId] = useState<any>(null);
	const [slipType, setSlipType] = useState<any>(400);
	const [selectedEmployee, setSelectedEmployee] = useState<any>(null);

	const [selectedResourceList, setSelectedResourceList] = useState<
		IDropDownListResponse[]
	>([{ label: "Create New", value: "create-new" }]);
	const [EditedResourceId, setEditedResourceId] = useState("");
	// const [newCreatedSlipId, setNewCreatedSlipId] = useState('');
	// const [newCreatedResourceId, setNewCreatedResourceId] = useState('');
	const [selectedOtherInformation, setSelectedOtherInformation] =
		useState(false);
	// const [editedRecordSlipCreateNew, setEditedRecordSlipCreateNew] = useState(false);

	// for delete row
	const [openDialog, setDialogOpen] = useState(false);
	const [apiAction, setApiAction] = useState("");
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [rL1SlipId, setRL1SlipId] = useState<any>("");
	const [oiInEdit, setOiInEdit] = useState(false);

	//one state which store both new cretaed and edited slip data
	const [RL1SlipRecord, setRL1SlipRecord] = useState<any>(undefined);
	// when  I setValue of otherinformation inside async calls method then facing issue while click on add more so we have to use state method to show otherinformation
	const [slipOtherInformation, setSlipOtherInformation] = useState<any>([]);

	const [dateOfBirth, setDateOfBirth] = useState<any>("");


	// for edit
	const queryClient = useQueryClient();
	const { id } = useParams();

	const { isPending: isPendingPayFrequencyDDL, data: payFrequencyDDLItems } =
		useGetPayFrequencyDDL(clientId, taxYear);

	const { isPending: isPendingEmployeeDDLItems, data: employeeDDLItems } =
		useGetEmployeeDDLItems(clientId, taxYear);

	const [notStartedSlipId, setNotStartedSlipId] = useState("");
	const [completedSlipId, setCompletedSlipId] = useState("");
	// useEffect(() => {
	// 	if (id !== undefined && onResourceSelectionAPIsCalls === false) {
	// 		(async () => {
	// 			try {
	// 				const response = await RL1SlipService.getRL1SlipById(
	// 					id,
	// 					clientId,
	// 					taxYear
	// 				);


	// 				if (
	// 					response.message ===
	// 					"RL-1 slip with this client id and year was not found."
	// 				) {
	// 					setNotStartedSlipId(id);
	// 				} else if (response) {
	// 					setCompletedSlipId(id);
	// 				}
	// 			} catch (error) {
	// 				console.error("Error fetching slip:", error);
	// 			}
	// 		})();
	// 	}
	// }, [id, onResourceSelectionAPIsCalls, clientId, taxYear]);

	// when Screens Reloads then which data loaded
	// useEffect(() => {
	// 	if (id !== undefined && onResourceSelectionAPIsCalls === false && employeeDDLItems) {
	// 		const employeeOrSlip: { isSlipData: boolean, data: any, selectedEmployee?: any } | null = findEmployeeOrSlip(employeeDDLItems, id)
	// 		
	// 		if (employeeOrSlip && employeeOrSlip.isSlipData) {
	// 			// slip DDL
	// 			if (employeeOrSlip.selectedEmployee.totalSlips && Array.isArray(employeeOrSlip.selectedEmployee.totalSlips)) {
	// 				let resourceSlipList: any[] =
	// 					employeeOrSlip.selectedEmployee.totalSlips.map((resourceSlip: any) => ({
	// 						label: resourceSlip.label,
	// 						value: resourceSlip.value,
	// 						totalSlips: resourceSlip.totalSlips,
	// 						slipType: resourceSlip.slipType
	// 					}));

	// 				resourceSlipList.unshift({
	// 					label: "Create New",
	// 					value: "create-new",
	// 				});


	// 			
	// 				setSelectedResourceSlipList(resourceSlipList);
	// 			}
	// 			setCompletedSlipId(employeeOrSlip.data.value);
	// 			setProvinceOfEmploymentId(employeeOrSlip.data.value);
	// 			setSelectedEmployee(employeeOrSlip.selectedEmployee.value);
	// 			setSlipType(employeeOrSlip.data.slipType);
	// 		} else {
	// 			if (employeeOrSlip) {
	// 				setNotStartedSlipId(employeeOrSlip.data.value);
	// 			}
	// 		}
	// 	}
	// }, [id, onResourceSelectionAPIsCalls, employeeDDLItems]);

	const isUserInteracting = useRef(false);
	const rl1SlipStoredData = useSelector((state: IAppState) => state.slips.rl1);

	useEffect(() => {
		if (!id || !employeeDDLItems || isUserInteracting.current) return;



		// const employeeOrSlip = findEmployeeOrSlip(employeeDDLItems, id);
		// if (!employeeOrSlip) return;

		// if (employeeOrSlip.isSlipData) {
		// 	if (Array.isArray(employeeOrSlip.selectedEmployee?.totalSlips)) {
		// 		const resourceSlipList = [
		// 			{ label: "Create New", value: "create-new" },
		// 			...employeeOrSlip.selectedEmployee.totalSlips.map((slip: any) => ({
		// 				label: slip.label,
		// 				value: slip.value,
		// 				totalSlips: slip.totalSlips,
		// 				slipType: slip.slipType,
		// 			})),
		// 		];
		// 		setSelectedResourceSlipList(resourceSlipList);
		// 	}
		// 	setCompletedSlipId(employeeOrSlip.data.value);
		// 	setProvinceOfEmploymentId(employeeOrSlip.data.value);
		// 	setSelectedEmployee(employeeOrSlip.selectedEmployee.value);
		// 	setSlipType(employeeOrSlip.data.slipType);
		// } else {
		// 	setNotStartedSlipId(employeeOrSlip.data.value);
		// }


		if (rl1SlipStoredData && rl1SlipStoredData.provinceId && rl1SlipStoredData.slipType) {
			console.log('rl1SlipStoredData', rl1SlipStoredData)
			const selectedEmployee = employeeDDLItems.find((x: any) => x.value === rl1SlipStoredData.employeeId);
			if (Array.isArray(selectedEmployee?.totalSlips)) {
				const resourceSlipList = [
					{ label: "Create New", value: "create-new" },
					...selectedEmployee.totalSlips.map((slip: any) => ({
						label: slip.label,
						value: slip.value,
						totalSlips: slip.totalSlips,
						slipType: slip.slipType,
					})),
				];
				setSelectedResourceSlipList(resourceSlipList);
			}

			// setCompletedSlipId(rl1SlipStoredData.provinceId);
			setProvinceOfEmploymentId(rl1SlipStoredData.provinceId);
			setSelectedEmployee(rl1SlipStoredData.employeeId);
			setSlipType(rl1SlipStoredData.slipType);
		} else if (rl1SlipStoredData && rl1SlipStoredData.employeeId && !rl1SlipStoredData.provinceId) {
			setNotStartedSlipId(rl1SlipStoredData.employeeId);
			const selectedEmployee = employeeDDLItems.find((x: any) => x.value === rl1SlipStoredData.employeeId);
			if (Array.isArray(selectedEmployee?.totalSlips)) {
				const resourceSlipList = [
					{ label: "Create New", value: "create-new" },
					...selectedEmployee.totalSlips.map((slip: any) => ({
						label: slip.label,
						value: slip.value,
						totalSlips: slip.totalSlips,
						slipType: slip.slipType,
					})),
				];
				setSelectedResourceSlipList(resourceSlipList);
			}
		}

	}, [id, employeeDDLItems, rl1SlipStoredData]);

	// Function to sort the data array by the label field
	// sort side cards items
	const sortData = (data: IDropDownListResponse[]): IDropDownListResponse[] => {
		return data.sort((a, b) => a.label.localeCompare(b.label));
	};

	const { isPending: isSubmitting, mutate: submitFlexFields } = useMutation({
		mutationFn: RL1SlipService.create,

		onSuccess: (
			res: IRL1SlipRequestPayload | IServerError | IResponse | any
		) => {

			if (res.data && res.data.id) {
				if (res.data && instanceOfIRL1SlipResponce(res.data)) {
					queryClient.invalidateQueries({
						queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, res.data.id],
					});
					queryClient.invalidateQueries({
						queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId, taxYear],
					});

					formMethods.setValue("id", res.data.id);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// refectchRL1SlipIds();
					scrollPanelFieldsToTop();
					if (res.status === 201 && selectedResourceSlip === "create-new") {
						// (async () => {
						// 	try {

						// 		const response: any =
						// 			await RL1SlipService.getResourceSlipDropDownList(
						// 				res.data?.resource?.externalId,
						// 				clientId,
						// 				taxYear
						// 			);
						// 		if (response && Array.isArray(response)) {
						// 			let resourceSlipList: IDropDownListResponse[] = response.map(
						// 				(resourceSlip: IDropDownListResponse) => ({
						// 					label: resourceSlip.label,
						// 					value: resourceSlip.value,
						// 				})
						// 			);

						// 			resourceSlipList.unshift({
						// 				label: "Create New",
						// 				value: "create-new",
						// 			});


						// 			setSelectedResourceSlipList(resourceSlipList);
						// 			formMethods.setValue("selectedSlip", res.data.id);
						// 			let path = `/compliance/rl1/setup/${res.data.id}`;
						// 			navigate(path);
						// 		}
						// 	} catch (error) {
						// 		console.error("Error fetching data:", error);
						// 	}
						// })();
						// setOnResourceSelectionAPIsCalls(true);
						let path = `/compliance/rl1/setup/${res.data.provinceOfEmployment.id}`;
						navigate(path);
						setOnResourceSelectionAPIsCalls(false);
						setSelectedResourceSlip(res.data.provinceOfEmployment.id);
					}
				}
			} else {
				setSnackbarData({
					open: true,
					message: res.message ? res.message : res.data.message,
					severity: "error",
				});
			}
			queryClient.invalidateQueries({
				queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId, taxYear],
			});
			//load slip Data
			// if (res.data && res.data?.resource) {
			// 	setRL1SlipRecord(res.data);
			// 	setSelectedResource(res.data?.resource?.externalId);
			// }

			// //set slip type to 400 because when we come back to slip without reload it will automatically be original
			selectedRL1SlipType = formMethods.getValues("slipType");

			// //otherinformation will update sselected items when its submitted
			setSelectedOtherInformation(true);
		},
		onError: (err) => {
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	//when cretae-new seleted from slip ddl
	const createNewActionFromSlipDDL = () => {
		setSelectedOtherInformation(false);
		setRL1SlipRecord(undefined);
		setSelectedResourceSlip("create-new");
		formMethods.setValue("selectedSlip", "create-new");
		formMethods.setValue("boxARevenusDEmploi", null);
		formMethods.setValue("boxBOtisationAuRRQ", null);
		formMethods.setValue("boxCCotaIAssuranceEmploi", null);
		formMethods.setValue("boxDCotisationAUnRPA", null);
		formMethods.setValue("boxEImpotDuQuebecRetenu", null);
		formMethods.setValue("boxFCotisationSyndicale", null);
		formMethods.setValue("boxGSalaireAdmissibleAuRRQ", null);
		formMethods.setValue("boxHCotisationAuRQAP", null);
		formMethods.setValue("boxISalaireAdmissibleAuRQAP", null);
		formMethods.setValue("boxJRegimePriveDassMaladie", null);
		formMethods.setValue("boxKVoyages", null);
		formMethods.setValue("boxLAutresAvantages", null);
		formMethods.setValue("boxMCommissions", null);
		formMethods.setValue("boxNDonsDeBienfaisance", null);
		formMethods.setValue("boxOAutresRevenus", null);
		formMethods.setValue("boxPRegimeDassInterentreprises", null);
		formMethods.setValue("boxQSalairesDifferes", null);
		formMethods.setValue("boxRRevenuSitueDansUneReserve", null);
		formMethods.setValue("boxSPourboiresRecus", null);
		formMethods.setValue("boxTPourboiresAttribues", null);
		formMethods.setValue("boxURetraiteProgressive", null);
		formMethods.setValue("boxVNourritureEtLogement", null);
		formMethods.setValue("boxWVehiculeAMoteur", null);
		formMethods.setValue("code", null);
		formMethods.setValue("boxAAdjRevenusDEmploi", null);
		formMethods.setValue("boxBAdjOtisationAuRRQ", null);
		formMethods.setValue("boxCAdjCotaIAssuranceEmploi", null);
		formMethods.setValue("boxEAdjImpotDuQuebecRetenu", null);
		formMethods.setValue("boxHAdjCotisationAuRQAP", null);
		formMethods.setValue("boxIAdjSalaireAdmissibleAuRQAP", null);
		formMethods.setValue("slipStatus", 200);
		formMethods.setValue("slipType", 400);
		formMethods.setValue("comparison", []);
		setSlipOtherInformation([
			{ amount: null, code: "null", label: "Empty Field" },
		]);
	};

	// const { isPending: isPendingGlobalVariables, data: editDataRecord } =
	// 	useGetGlobalVariables(taxYear);
	// const globalVariablesData: any = editDataRecord;

	// const { isPending: isPendingCountryDDL, data: countryList } =
	// 	useGetCountryDDL();
	const { isLoading: isLoadingSummaryGetData, data: rl1SummaryData } =
		useGetRL1SummaryData(clientId, selectedRL1SummaryType, taxYear);

	// const {
	// 	isPending: loadingSlipIds,
	// 	data: rl1SlipIds,
	// 	refetch: refectchRL1SlipIds,
	// } = useGetSlipIds("RL1", clientId, taxYear);

	// const { isPending: isPendingClientDataById, data: companyGetByIdRecord } =
	// 	useGetCompanyData(clientId, navigateToLogout);

	// useEffect(() => {
	//
	// 	if (companyGetByIdRecord && companyGetByIdRecord.metaFields) {
	// 		const paymentFor = companyGetByIdRecord.metaFields.find(
	// 			(item: any) => item.name === "invoice_payment_for"
	// 		);
	// 	
	// 		setInvoicePaymentFor(paymentFor ? parseInt(paymentFor.value) : 10);
	// 	}
	// }, [companyGetByIdRecord]);



	const { isPending: isPendingMaskStatus, data: maskStatus } =
		useGetMaskStatus();

	useEffect(() => {
		if (employeeDDLItems) {
			if (employeeDDLItems && Array.isArray(employeeDDLItems)) {
				let resources: IDropDownListResponse[] = sortDDLByLabel(employeeDDLItems).map(
					(resourceItem: IDropDownListResponse) => ({
						// id: resourceItem.id,
						label: resourceItem.label,
						value: resourceItem.value,
					})
				);

				resources.unshift({
					label: "Create New",
					value: "create-new",
				});

				setSelectedResourceList(resources);
			}
			setResourceListWithoutCreateNew(sortData(employeeDDLItems));
		}
	}, [employeeDDLItems]);

	// resourceDataById in function
	const resourceDataByIdPass = useCallback(
		(resourceDataById: any) => {

			setIsPendingSlipData(true);
			if (resourceDataById) {
				Object.keys(resourceDataById).forEach((fieldName) => {
					const fieldValue = resourceDataById[fieldName];



					// Always set top-level values
					formMethods.setValue(
						fieldName,
						fieldValue !== null && fieldValue !== "" ? fieldValue : ""
					);

					if (fieldName === "address") {
						Object.keys(fieldValue).forEach((resourceFieldName) => {
							const resourceFieldValue = fieldValue[resourceFieldName];
							formMethods.setValue(
								resourceFieldName,
								resourceFieldValue !== null && resourceFieldValue !== ""
									? resourceFieldValue
									: ""
							);
							if (resourceFieldName === "email") {
								if (resourceFieldValue !== null) {
									formMethods.setValue(resourceFieldName, resourceFieldValue);
								} else {
									if (maskStatus) {
										formMethods.setValue(
											resourceFieldName,
											"ze*****3@gmail.com"
										);
									} else {
										formMethods.setValue(resourceFieldName, "");
									}
								}
							}
							if (resourceFieldName === "countryType") {
								if (
									resourceDataById.address.country.shortCode === "CAN" &&
									canadaProvinces
								) {
									setProvinceStateDDLinUpdate(canadaProvinces);
									setProvinceStateLabelinUpdate(
										resourceFieldValue ? "province" : "state"
									);
								} else {
									(async () => {
										try {
											setProvinceDDLLoading(true);
											const responce =
												await CountryService.getProvinceOrStateDDL(
													navigateToLogout,
													resourceDataById.address.country.id,
													resourceFieldValue ? "province" : "state"
												);

											setProvinceStateDDLinUpdate(responce);
											setProvinceStateLabelinUpdate(
												resourceFieldValue ? "province" : "state"
											);
										} catch {

										} finally {
											setProvinceDDLLoading(false);
										}
									})();
								}
							}
							if (resourceFieldName === "country") {
								formMethods.setValue(
									resourceFieldName,
									resourceFieldValue.id ?? undefined
								);
							}
							if (resourceFieldName === "province") {
								formMethods.setValue(
									resourceFieldName,
									resourceFieldValue.id ?? undefined
								);
								(async () => {
									try {
										setProvinceDDLLoading(true);
										const responce = await CityService.getCityDDL(
											navigateToLogout,
											resourceFieldValue.id
										);

										setCityDDLinUpdate(responce);
									} catch {

										setProvinceDDLLoading(false);
									} finally {
										setProvinceDDLLoading(false);
									}
								})();
							}
							if (resourceFieldName === "state") {
								formMethods.setValue(
									resourceFieldName,
									resourceFieldValue.id ?? undefined
								);
							}
							if (resourceFieldName === "city") {
								// formMethods.setValue(resourceFieldName, resourceFieldValue.id ?? undefined);
								formMethods.setValue(
									resourceFieldName,
									resourceFieldValue.id ?? undefined
								);
							}
							if (resourceFieldName === "addressLine1") {
								formMethods.setValue("address", resourceFieldValue);
							}
						});
					}
					if (fieldName === "employeePayroll") {
						Object.keys(fieldValue).forEach((resourceFieldName) => {
							const resourceFieldValue = fieldValue[resourceFieldName];
							if (resourceFieldName === "payFrequency") {

								formMethods.setValue(
									resourceFieldName,
									Number(resourceFieldValue)
								);
								// formMethods.setValue(
								// 	"pensionablePeriod",
								// 	Number(resourceFieldValue)
								// );
							}
						});
					}
					if (fieldName === "socialInsuranceNumber" && fieldValue) {
						const formattedNumber = fieldValue.replace(
							/(\d{3})(\d{3})(\d{3})/,
							"$1-$2-$3"
						);
						formMethods.setValue("socialInsuranceNumber", formattedNumber);
					}
					if (fieldName === "dateOfBirth") {
						if (fieldValue !== "") {
							formMethods.setValue("dateOfBirth", fieldValue);
							if (fieldValue.charAt(2) === "*") {
								formMethods.setValue("dateOfBirth", fieldValue);
								setDateOfBirth(fieldValue);
							} else {
								const defaultDate = new Date(fieldValue);
								formMethods.setValue("dateOfBirth", defaultDate);
								setDateOfBirth(formatDate(defaultDate as Date));
							}
						}
					}
					if (fieldName === "id" && onResourceSelectionAPIsCalls === false) {
						//for auto selected card
						setSelectedEmployee(String(fieldValue));
						setSelectedResource(fieldValue);
					}
				});
				createNewActionFromSlipDDL();
				setIsPendingSlipData(false);
			}
		},
		[onResourceSelectionAPIsCalls]
	);

	// slipDataById in function
	const slipDataByIdPass = useCallback(
		(slipDataById: any, onResourceSelectionAPIsCalls: boolean) => {

			setIsPendingSlipData(true);
			if (slipDataById) {
				Object.keys(slipDataById).forEach((fieldName) => {
					const fieldValue = slipDataById[fieldName];



					// Always set top-level values
					formMethods.setValue(fieldName, fieldValue);

					if (typeof fieldValue !== "object" || fieldValue === null) {
						formMethods.setValue(fieldName, fieldValue ?? undefined);
					} else {

						Object.keys(fieldValue).forEach((objFieldName: any) => {
							const objFieldValue = fieldValue[objFieldName];


							if (typeof objFieldValue !== "object") {
								formMethods.setValue(objFieldName, objFieldValue ?? undefined);
							}
							if (objFieldName === "dateOfBirth") {
								if (objFieldValue) {
									if (objFieldValue.charAt(2) === "*") {
										formMethods.setValue("dateOfBirth", objFieldValue);
										setDateOfBirth(objFieldValue);
									} else {
										const parsed = new Date(objFieldValue);
										formMethods.setValue("dateOfBirth", parsed);
										setDateOfBirth(formatDate(parsed));
									}
								}
							}
							if (fieldName === "resource") {
								if (objFieldName === "externalId") {
									// formMethods.setValue("selectedEmployee", objFieldValue);
									setSelectedEmployee(String(objFieldValue));
									setSelectedResource(objFieldValue);
									setEditedResourceId(fieldValue.externalId);
									// if (!onResourceSelectionAPIsCalls) {
									// 	(async () => {
									// 		try {
									// 			const response =
									// 				await T4SlipService.getResourceSlipDropDownList(
									// 					objFieldValue,
									// 					clientId,
									// 					taxYear
									// 				);
									// 			if (Array.isArray(response)) {
									// 				const resourceSlipList = [
									// 					{ label: "Create New", value: "create-new" },
									// 					...response.map((r) => ({
									// 						label: r.label,
									// 						value: r.value,
									// 					})),
									// 				];
									// 				setSelectedResourceSlipList(resourceSlipList);
									// 			}
									// 		} catch (err) {
									// 			console.error("Error fetching resource slips", err);
									// 		}
									// 	})();
									// }
								}

								if (objFieldName === "email") {
									if (objFieldValue) {
										formMethods.setValue("email", objFieldValue);
									} else {
										formMethods.setValue(
											"email",
											maskStatus ? "ze*****3@gmail.com" : ""
										);
									}
								}
							}
							if (objFieldName === "countryType") {
								if (
									slipDataById.address.country.shortCode === "CAN" &&
									canadaProvinces
								) {
									setProvinceStateDDLinUpdate(canadaProvinces);
									setProvinceStateLabelinUpdate(
										objFieldValue ? "province" : "state"
									);
								} else {
									(async () => {
										try {
											setProvinceDDLLoading(true);
											const responce =
												await CountryService.getProvinceOrStateDDL(
													navigateToLogout,
													slipDataById.address.country.id,
													objFieldValue ? "province" : "state"
												);
											setProvinceStateDDLinUpdate(responce);
											setProvinceStateLabelinUpdate(
												objFieldValue ? "province" : "state"
											);
										} finally {
											setProvinceDDLLoading(false);
										}
									})();
								}
							}

							if (objFieldName === "country") {
								formMethods.setValue(
									objFieldName,
									objFieldValue?.id ?? undefined
								);
							}

							if (objFieldName === "province") {
								formMethods.setValue(
									objFieldName,
									objFieldValue?.id ?? undefined
								);
								(async () => {
									try {
										setProvinceDDLLoading(true);
										const responce = await CityService.getCityDDL(
											navigateToLogout,
											objFieldValue.id
										);
										setCityDDLinUpdate(responce);
									} finally {
										setProvinceDDLLoading(false);
									}
								})();
							}

							if (objFieldName === "state") {
								formMethods.setValue(
									objFieldName,
									objFieldValue?.id ?? undefined
								);
							}

							if (objFieldName === "city") {
								formMethods.setValue(
									objFieldName,
									objFieldValue?.id ?? undefined
								);
							}

							if (objFieldName === "postCode") {
								formMethods.setValue(objFieldName, objFieldValue ?? "");
							}
							if (objFieldName === "provinceOfEmployment") {
								// now we get by id using poe id 
								setSelectedResourceSlip(objFieldValue?.id);
								formMethods.setValue("selectedSlip", objFieldValue?.id);
								let path = `/compliance/rl1/setup/${objFieldValue?.id}`;
								navigate(path);
							}
							if (objFieldName === "socialInsuranceNumber") {
								const formatted = objFieldValue?.replace(
									/(\d{3})(\d{3})(\d{3})/,
									"$1-$2-$3"
								);
								formMethods.setValue("socialInsuranceNumber", formatted);
							}
							if (objFieldName !== "email" && objFieldValue === null) {
								formMethods.setValue(objFieldName, "");
							}
						});
					}
					//set slip type according to edited row data for submit button action
					if (fieldName === "slipType") {
						selectedRL1SlipType = fieldValue;
					}
					if (fieldName === "otherInformation") {
						setSlipOtherInformation([]);
						if (fieldValue && fieldValue !== null && fieldValue.length !== 0) {
							setOiInEdit(true);
							formMethods.setValue("comparison", fieldValue);
						} else {
							setOiInEdit(true);
							formMethods.setValue("comparison", [
								{ amount: null, code: "", label: "" },
							]);
						}
					}

					if (fieldName === "id") {
						// setSelectedResourceSlip(fieldValue);
						// formMethods.setValue("selectedSlip", fieldValue);
						// let path = `/compliance/rl1/setup/${fieldValue}`;
						// navigate(path);
					}
					if (fieldName === "slipData") {
						Object.keys(fieldValue).forEach((slipDataFieldName: any) => {
							const slipDataFieldValue = fieldValue[slipDataFieldName];
							formMethods.setValue(
								slipDataFieldName,
								slipDataFieldValue && slipDataFieldValue !== null
									? parseFloat(slipDataFieldValue).toFixed(2)
									: null
							);
							if (slipDataFieldName === "boxOAutresRevenus") {
								formMethods.setValue(
									slipDataFieldName,
									slipDataFieldValue !== null
										? parseFloat(slipDataFieldValue).toFixed(2)
										: null
								);
							}
							if (slipDataFieldName === "code") {
								formMethods.setValue(
									slipDataFieldName,
									slipDataFieldValue !== null ? slipDataFieldValue : null
								);
							}
						});
					}
				});
			}
			setIsPendingSlipData(false);
		},
		[]
	);

	// for edit
	//for that slips which are completed
	// const { isPending: isPendingData, data: selectedRL1SlipsData } = useGetData(
	// 	completedSlipId,
	// 	clientId,
	// 	taxYear
	// );

	const { isPending: isPendingData, data: selectedRL1SlipsData } = useGetData(
		selectedEmployee,
		provinceOfEmploymentId,
		slipType,
		clientId,
		taxYear
	);

	useEffect(() => {
		//get by id slip
		setIsPendingSlipData(true);
		setTimeout(() => {
			setIsPendingSlipData(false);
		}, 2000);
		const fetchData = async () => {
			try {
				const response: any = await RL1SlipService.getRL1SlipById(
					completedSlipId,
					clientId,
					taxYear
				);

				setRL1SlipRecord(response);
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		};

		fetchData();
	}, []);

	useEffect(() => {
		if (selectedRL1SlipsData) {
			setRL1SlipRecord(selectedRL1SlipsData);
		}
	}, [selectedRL1SlipsData]);


	//for that slips which are not started yet
	const {
		isPending: isPendingNotStartedSlipId,
		data: selectedNotStartedResourceData,
		// refetch: refetchResourceSlips,
	} = useGetResourceInformationById(notStartedSlipId, clientId, "Employee");


	const [RL1OtherInformationList, setRL1OtherInformationList] =
		useState<any>(undefined);
	useEffect(() => {
		const fetchData = async () => {
			try {
				setIsPendingSlipData(true);
				const response: any = await RL1OtherInformationService.getRL1OI();
				setRL1OtherInformationList(response);
			} catch (error) {
				console.error("Error fetching data:", error);
			} finally {
				setIsPendingSlipData(false);
			}
		};
		fetchData();
	}, []);

	const ExtendedValidationSchema = RL1SlipSetupValidationSchema.shape({
		postCode: yup.string().when("country", (country: any, schema: any) => {

			const selectedCountry = countryList.find(
				(c: any) => c.value === country[0]
			);

			if (selectedCountry?.shortCode === "CAN") {
				return schema
					.required("Post Code is required")
					.length(6, "Post Code must be exactly 6 characters");
			}
			return schema; // Unchanged for other countries
		}),
		zipCode: yup.string().when("country", (country: any, schema: any) => {
			const selectedCountry = countryList.find(
				(c: any) => c.value === country[0]
			);
			if (selectedCountry?.shortCode === "USA") {
				return schema
					.required("Zip Code is required")
					.length(5, "Zip Code must be exactly 5 characters");
			}
			return schema; // Unchanged for other countries
		}),
	});

	const DEFAULT_VALUES = {
		boxARevenusDEmploi: null,
		boxBOtisationAuRRQ: null,
		boxBBOtisationAuRRQ: null,
		boxCCotaIAssuranceEmploi: null,
		boxDCotisationAUnRPA: null,
		boxEImpotDuQuebecRetenu: null,
		boxFCotisationSyndicale: null,
		boxGSalaireAdmissibleAuRRQ: null,
		boxHCotisationAuRQAP: null,
		boxISalaireAdmissibleAuRQAP: null,
		boxJRegimePriveDassMaladie: null,
		boxKVoyages: null,
		boxLAutresAvantages: null,
		boxMCommissions: null,
		boxNDonsDeBienfaisance: null,
		boxOAutresRevenus: null,
		boxPRegimeDassInterentreprises: null,
		boxQSalairesDifferes: null,
		boxRRevenuSitueDansUneReserve: null,
		boxSPourboiresRecus: null,

		boxTPourboiresAttribues: null,
		boxURetraiteProgressive: null,
		boxVNourritureEtLogement: null,
		boxWVehiculeAMoteur: null,
		code: null,

		// employee Info

		socialInsuranceNumber: undefined,
		firstName: undefined,
		initials: undefined,
		lastName: undefined,
		dateOfBirth: null,

		// address
		address: undefined,
		// Country: undefined,
		province: undefined,
		city: undefined,
		postCode: undefined,
		zipCode: undefined,
		email: undefined,

		// Filing Data

		slipType: 400,
		payFrequency: 26,
		// pensionablePeriod: 26,
		slipStatus: 200,
	};

	const formMethods = useForm<any>({
		// resolver: yupResolver(RL1SlipSetupValidationSchema),
		resolver: yupResolver(ExtendedValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
		defaultValues: DEFAULT_VALUES,
	});



	/**
	 * Handle when the form is submitted.
	 *
	 * @param {IRL1SlipRequestPayload} formData
	 */
	const onSubmit = async (formData: any) => {

		const SelectedCountry: any = countryList.find(
			(e: any) => e.value === formData.country
		);

		try {
			setIsPendingData(true);
			const ProvinceOrStateDDL = await CountryService.getProvinceOrStateDDL(
				navigateToLogout,
				SelectedCountry.value,
				SelectedCountry.countryType
			);
			const selectedProvinceOrState = formData.province
				? ProvinceOrStateDDL.find((e: any) => e.value === formData.province)
				: formData.state
					? ProvinceOrStateDDL.find((e: any) => e.value === formData.state)
					: undefined;

			const selectedPOE = ProvinceOrStateDDL.find(
				(e: any) => e.shortCode === "QC"
			);



			//other Information
			const getValue = formMethods.getValues("comparison");
			const finalOtherInformatioItemsRL1 = FilteredSelectedOtherInfoRL1.map(
				(item: any) => {
					const valueItem = getValue.find(
						(value: any) => value.code === item.code
					);
					const getLabelIfMissingInItem: any =
						RL1OtherInformationList &&
						RL1OtherInformationList.find(
							(value: any) => value.value === item.code
						);
					return {
						...item,
						amount: valueItem.amount,
						label: getLabelIfMissingInItem.label,
					};
				}
			);



			const requestPayload: IRL1SlipRequestPayload = {
				clientId: clientId,
				taxYear: taxYear,
				id:
					selectedRL1SlipsData && selectedRL1SlipsData.resource
						? // && editedRecordSlipCreateNew === false
						selectedRL1SlipsData.id
						: RL1SlipRecord && RL1SlipRecord.id
							? RL1SlipRecord.id
							: // : newCreatedSlipId !== '' && editedRecordSlipCreateNew === false ? newCreatedSlipId
							undefined,
				// reflectMasterData: formData.reflectMasterData,
				slipType: formData.slipType,
				slipStatus: formData.slipStatus,
				// pensionablePeriod: formData.pensionablePeriod,
				otherInformation:
					formData.comparison[0].code !== ""
						? finalOtherInformatioItemsRL1
						: [],
				resource: {
					externalId:
						selectedResource !== "create-new"
							? selectedResource
							: selectedRL1SlipsData && selectedRL1SlipsData.resource
								? selectedRL1SlipsData?.resource.externalId
								: // : newCreatedResourceId !== '' ? newCreatedResourceId
								selectedNotStartedResourceData &&
									selectedNotStartedResourceData.id
									? selectedNotStartedResourceData.id
									: undefined,
					// externalId:"6daf1279-a74f-458a-a973-5f8eda0c72f4", //resource id of => //testRL ed3 test
					firstName: formData.firstName,
					initials: formData.initials,
					lastName: formData.lastName,
					// dateOfBirth:
					// 	dateOfBirth.charAt(2) === "*"
					// 		? undefined
					// 		: dateOfBirth !== "" || null
					// 		? dateOfBirth
					// 		: undefined,
					dateOfBirth:
						formData.dateOfBirth !== "" && formatDate(formData.dateOfBirth),
					socialInsuranceNumber: formData.socialInsuranceNumber.replace(
						/-/g,
						""
					),
					address: formData.address,
					city: formData.city,
					countryType: formData.province ? true : false,
					country: {
						id: SelectedCountry.value,
						name: SelectedCountry.label,
						shortCode: SelectedCountry.shortCode,
					},
					province: formData.province
						? {
							id: selectedProvinceOrState.value,
							name: selectedProvinceOrState.label,
							shortCode: selectedProvinceOrState.shortCode,
						}
						: undefined,
					states: formData.state
						? {
							id: selectedProvinceOrState.value,
							name: selectedProvinceOrState.label,
							shortCode: selectedProvinceOrState.shortCode,
						}
						: undefined,
					postCode: formData.postCode
						? formData.postCode.replace(/[a-z]/g, (match: string) =>
							match.toUpperCase()
						)
						: undefined,
					zipCode: formData.zipCode ? formData.zipCode : undefined,
					provinceOfEmployment: {
						id: selectedPOE.value,
						name: selectedPOE.label,
						shortCode: selectedPOE.shortCode,
					},
					email:
						formData.email !== "" && formData.email !== "ze*****3@gmail.com"
							? formData.email
							: undefined,
					payFrequency: formData.payFrequency,
				},
				overRemittance: 0,
				slipData: {
					boxARevenusDEmploi:
						formData.boxARevenusDEmploi && formData.boxARevenusDEmploi !== null
							? formData.boxARevenusDEmploi
							: 0,
					boxBOtisationAuRRQ:
						formData.boxBOtisationAuRRQ && formData.boxBOtisationAuRRQ !== null
							? formData.boxBOtisationAuRRQ
							: 0,
					boxBBOtisationAuRRQ:
						taxYear > 2023 &&
							formData.boxBBOtisationAuRRQ &&
							formData.boxBBOtisationAuRRQ !== null
							? formData.boxBBOtisationAuRRQ
							: 0,
					boxCCotaIAssuranceEmploi:
						formData.boxCCotaIAssuranceEmploi &&
							formData.boxCCotaIAssuranceEmploi !== null
							? formData.boxCCotaIAssuranceEmploi
							: 0,
					boxDCotisationAUnRPA:
						formData.boxDCotisationAUnRPA &&
							formData.boxDCotisationAUnRPA !== null
							? formData.boxDCotisationAUnRPA
							: 0,
					boxEImpotDuQuebecRetenu:
						formData.boxEImpotDuQuebecRetenu &&
							formData.boxEImpotDuQuebecRetenu !== null
							? formData.boxEImpotDuQuebecRetenu
							: 0,
					boxFCotisationSyndicale:
						formData.boxFCotisationSyndicale &&
							formData.boxFCotisationSyndicale !== null
							? formData.boxFCotisationSyndicale
							: 0,
					boxGSalaireAdmissibleAuRRQ:
						formData.boxGSalaireAdmissibleAuRRQ &&
							formData.boxGSalaireAdmissibleAuRRQ !== null
							? formData.boxGSalaireAdmissibleAuRRQ
							: 0,
					boxHCotisationAuRQAP:
						formData.boxHCotisationAuRQAP &&
							formData.boxHCotisationAuRQAP !== null
							? formData.boxHCotisationAuRQAP
							: 0,
					boxISalaireAdmissibleAuRQAP:
						formData.boxISalaireAdmissibleAuRQAP &&
							formData.boxISalaireAdmissibleAuRQAP !== null
							? formData.boxISalaireAdmissibleAuRQAP
							: 0,
					boxJRegimePriveDassMaladie:
						formData.boxJRegimePriveDassMaladie &&
							formData.boxJRegimePriveDassMaladie !== null
							? formData.boxJRegimePriveDassMaladie
							: 0,
					boxKVoyages:
						formData.boxKVoyages && formData.boxKVoyages !== null
							? formData.boxKVoyages
							: 0,
					boxLAutresAvantages:
						formData.boxLAutresAvantages &&
							formData.boxLAutresAvantages !== null
							? formData.boxLAutresAvantages
							: 0,
					boxMCommissions:
						formData.boxMCommissions && formData.boxMCommissions !== null
							? formData.boxMCommissions
							: 0,
					boxNDonsDeBienfaisance:
						formData.boxNDonsDeBienfaisance &&
							formData.boxNDonsDeBienfaisance !== null
							? formData.boxNDonsDeBienfaisance
							: 0,
					boxOAutresRevenus:
						formData.boxOAutresRevenus &&
							formData.boxOAutresRevenus !== "" &&
							formData.boxOAutresRevenus !== null
							? formData.boxOAutresRevenus
							: null,
					boxPRegimeDassInterentreprises:
						formData.boxPRegimeDassInterentreprises &&
							formData.boxPRegimeDassInterentreprises !== null
							? formData.boxPRegimeDassInterentreprises
							: 0,
					boxQSalairesDifferes:
						formData.boxQSalairesDifferes &&
							formData.boxQSalairesDifferes !== null
							? formData.boxQSalairesDifferes
							: 0,
					boxRRevenuSitueDansUneReserve:
						formData.boxRRevenuSitueDansUneReserve &&
							formData.boxRRevenuSitueDansUneReserve !== null
							? formData.boxRRevenuSitueDansUneReserve
							: 0,
					boxSPourboiresRecus:
						formData.boxSPourboiresRecus &&
							formData.boxSPourboiresRecus !== null
							? formData.boxSPourboiresRecus
							: 0,
					boxTPourboiresAttribues:
						formData.boxTPourboiresAttribues &&
							formData.boxTPourboiresAttribues !== null
							? formData.boxTPourboiresAttribues
							: 0,
					boxURetraiteProgressive:
						formData.boxURetraiteProgressive &&
							formData.boxURetraiteProgressive !== null &&
							formData.boxURetraiteProgressive !== "" &&
							taxYear < 2024
							? formData.boxURetraiteProgressive
							: 0,
					boxVNourritureEtLogement:
						formData.boxVNourritureEtLogement &&
							formData.boxVNourritureEtLogement !== null
							? formData.boxVNourritureEtLogement
							: 0,
					boxWVehiculeAMoteur:
						formData.boxWVehiculeAMoteur &&
							formData.boxWVehiculeAMoteur !== null
							? formData.boxWVehiculeAMoteur
							: 0,
					code: formData.code !== undefined ? formData.code : null,
				},
			};


			submitFlexFields(requestPayload);
		} catch {

		} finally {
			setIsPendingData(false);
		}
	};

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		formMethods.setValue("comparison", [{ amount: null, code: "", label: "" }]);
		setSlipOtherInformation([]);
		scrollPanelFieldsToTop();
		let path = `/compliance/rl1/setup`;
		navigate(path);
		setRL1SlipRecord(undefined);
	};

	// For Delete Row

	const { isPending: isDeleting, mutate: deleteRL1SlipById } = useMutation({
		mutationFn: RL1SlipService.delRL1Slip,

		onSuccess: (res: any | IServerError | IResponse) => {

			if (typeof res === "string") {
				// remove the cache of the Year fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
				setRL1SlipRecord(undefined);
				scrollPanelFieldsToTop();
				// refectchRL1SlipIds();
			} else {
				setSnackbarData({
					open: true,
					message: res.message,
					severity: "error",
				});
			}

			//load Employee Data
			if (res) {
				const selectedEmployee = formMethods.getValues("selectedEmployee");

				if (selectedEmployee !== "create-new") {
					let path = `/compliance/rl1/setup/${selectedEmployee}`;
					navigate(path);
					const fetchData = async () => {
						try {
							const response: any =
								await RL1SlipService.getResourceSlipDropDownList(
									selectedEmployee,
									clientId,
									taxYear
								);


							if (response && Array.isArray(response)) {
								let resourceSlipList: IDropDownListResponse[] = response.map(
									(resourceSlip: IDropDownListResponse) => ({
										label: resourceSlip.label,
										value: resourceSlip.value,
									})
								);

								resourceSlipList.unshift({
									label: "Create New",
									value: "create-new",
								});


								setSelectedResourceSlipList(resourceSlipList);
								formMethods.setValue("selectedSlip", resourceSlipList[0].value);
								createNewActionFromSlipDDL();
								formMethods.setValue("comparison", [
									{ amount: null, code: "", label: "" },
								]);
							}
						} catch (error) {
							console.error("Error fetching data:", error);
						}
					};

					fetchData();
				}
			}

			//set slip type to 400 because when we come back to slip without reload it will automatically be original
			selectedRL1SlipType = formMethods.getValues("slipType");

			//otherinformation will update sselected items when its submitted
			setSelectedOtherInformation(true);
		},
		onError: (err: any) => {

			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				// message: "Something went wrong, try again later!",
				message: err.message,
				severity: "error",
			});
		},
	});

	const deleteRL1SlipField = () => {
		if (singleDelete) {
			let payload = {
				rL1SlipId,
				clientId,
				taxYear,
			};
			setSingleDelete(false);
			deleteRL1SlipById(payload);
			setDialogOpen(false);
		}
	};

	const onDeleteClicked = () => {
		setDialogOpen(true);
		setSingleDelete(true);
		setApiAction("delete");
		if (
			selectedRL1SlipsData &&
			selectedRL1SlipsData.resource
			// && editedRecordSlipCreateNew === false
		) {
			setRL1SlipId(selectedRL1SlipsData.id);
		}
	};

	const savePdfAsFile = (pdfData: any, filename: any) => {
		// const blob = new Blob([xmlData], { type: 'pdf;charset=utf-8' });
		const blob = new Blob([pdfData], { type: "pdf;charset=utf-8" });
		FileSaver.saveAs(blob, filename);
	};
	const onPrintClicked = async (): Promise<void> => {
		if (maskStatus) {
			setIsPendingData(false);
			setSnackbarData({
				open: true,
				message: "Please unmask your data.",
				severity: "error",
			});
		} else {
			// if (invoicePaymentFor === 10) {
			// 	try {
			// 		const previousYearInvoiceResponse: any =
			// 			await ReportsService.getPreviousYearInvoice(clientId, taxYear - 1);
			// 		try {
			// 			const response: any = await ReportsService.createInvoice(
			// 				clientId,
			// 				taxYear
			// 			);
			// 			setIsPendingData(false);
			// 		
			// 			if (
			// 				previousYearInvoiceResponse.message ===
			// 					"Slips not found for invoice." &&
			// 				response.message === "Slips not found for invoice."
			// 			) {
			// 				if (
			// 					rl1SlipIds &&
			// 					rl1SlipIds.generalAuditStatus !== null &&
			// 					rl1SlipIds.generalAuditStatus === true &&
			// 					rl1SlipIds &&
			// 					rl1SlipIds.auditStatus !== null &&
			// 					rl1SlipIds.auditStatus === true
			// 				) {
			let requestPayload = [
				{
					"employeeId": selectedRL1SlipsData.resource.externalId,
					// "slipType": selectedRL1SlipsData.slipType === "Original" ? 400 : selectedRL1SlipsData.slipType === "Amended" ? 200 : selectedRL1SlipsData.slipType === "Cancelled" ? 300 : 100,
					"slipType": selectedRL1SlipsData.slipType,
					"provinceId": selectedRL1SlipsData.resource.provinceOfEmployment.id
				}
			]
			setIsPendingData(true);
			try {
				// const response: any = await PrintingService.createSingleRL1PdfPrint(clientId, EditedResourceId, formMethods.getValues("slipType"), taxYear);
				// let pdfIds = `rl1_slip_ids=${id}`;

				const response: any = await PrintingService.createBulkRL1PdfPrint(
					clientId,
					// pdfIds,
					taxYear,
					requestPayload,
				);
				if (response.status === 400) {
					setSnackbarData({
						open: true,
						message: response.data.message
							? response.data.message
							: "Something went wrong.",
						// message: "Please Unmask sensitive data for PDF printing.",
						severity: "error",
					});
				} else {
					const filename = `RL1slip-${clientName}.pdf`;
					savePdfAsFile(response, filename);
				}
				setIsPendingData(false);
			} catch (err) {
			}
			setIsPendingData(false);
			// 				} else {
			// 					setIsPendingData(false);
			// 					setSnackbarData({
			// 						open: true,
			// 						message: (
			// 							<>
			// 								Please load Audit in the menu, press Run RL-1 Audit and
			// 								clear all audit items to generate documents.{" "}
			// 								<a
			// 									href="https://appv3.taxslips.com/#/audit/filing"
			// 									style={{
			// 										color: "#aa1010",
			// 										textDecoration: "none",
			// 										fontWeight: "bold",
			// 									}}
			// 								>
			// 									Click here to view
			// 								</a>
			// 							</>
			// 						),
			// 						severity: "error",
			// 						autoHide: false,
			// 					});
			// 				}
			// 			} else if (
			// 				response?.id != null &&
			// 				previousYearInvoiceResponse?.id != null
			// 			) {
			// 				
			// 				setInvoiceData([previousYearInvoiceResponse, response]);
			// 				setInvoiceDialogOpen(true);
			// 			} else if (
			// 				previousYearInvoiceResponse?.id != null &&
			// 				response?.message === "Slips not found for invoice."
			// 			) {
			// 				
			// 				setInvoiceData([previousYearInvoiceResponse]);
			// 				setInvoiceDialogOpen(true);
			// 			} else if (
			// 				response?.id != null &&
			// 				previousYearInvoiceResponse?.message ===
			// 					"Slips not found for invoice."
			// 			) {
			// 				
			// 				setInvoiceData([response]);
			// 				setInvoiceDialogOpen(true);
			// 			} else {
			// 				setSnackbarData({
			// 					open: true,
			// 					message: "Something went wrong.",
			// 					severity: "error",
			// 				});
			// 			}
			// 			setIsPendingData(false);
			// 		} catch (err) {
			// 			
			// 			setIsPendingData(false);
			// 		}
			// 	} catch (err) {
			// 	
			// 		setIsPendingData(false);
			// 	}
			// } else {
			// 	setIsPendingData(true);
			// 	try {
			// 		const response: any = await ReportsService.createInvoice(
			// 			clientId,
			// 			taxYear
			// 		);
			// 		setIsPendingData(false);
			// 		
			// 		if (response.message === "Slips not found for invoice.") {
			// 			if (
			// 				rl1SlipIds &&
			// 				rl1SlipIds.generalAuditStatus !== null &&
			// 				rl1SlipIds.generalAuditStatus === true &&
			// 				rl1SlipIds &&
			// 				rl1SlipIds.auditStatus !== null &&
			// 				rl1SlipIds.auditStatus === true
			// 			) {
			// 				setIsPendingData(true);
			// 				try {
			// 					// const response: any = await PrintingService.createSingleRL1PdfPrint(clientId, EditedResourceId, formMethods.getValues("slipType"), taxYear);
			// 					let pdfIds = `rl1_slip_ids=${id}`;
			// 					const response: any =
			// 						await PrintingService.createBulkRL1PdfPrint(
			// 							clientId,
			// 							pdfIds,
			// 							taxYear
			// 						);
			// 					if (response.status === 400) {
			// 						setSnackbarData({
			// 							open: true,
			// 							message: response.data.message
			// 								? response.data.message
			// 								: "Something went wrong.",
			// 							// message: "Please Unmask sensitive data for PDF printing.",
			// 							severity: "error",
			// 						});
			// 					} else {
			// 						const filename = `RL1slip-${clientName}.pdf`;
			// 						savePdfAsFile(response, filename);
			// 					}
			// 					setIsPendingData(false);
			// 				} catch (err) {
			// 					
			// 					// alert(err)
			// 				}
			// 				// }
			// 				setIsPendingData(false);
			// 			} else {
			// 				setIsPendingData(false);
			// 				setSnackbarData({
			// 					open: true,
			// 					message: (
			// 						<>
			// 							Please load Audit in the menu, press Run RL-1 Audit and
			// 							clear all audit items to generate documents.{" "}
			// 							<a
			// 								href="https://appv3.taxslips.com/#/audit/filing"
			// 								style={{
			// 									color: "#aa1010",
			// 									textDecoration: "none",
			// 									fontWeight: "bold",
			// 								}}
			// 							>
			// 								Click here to view
			// 							</a>
			// 						</>
			// 					),
			// 					severity: "error",
			// 					autoHide: false,
			// 				});
			// 			}
			// 			// } catch (err: any) {
			// 			//   setIsPendingData(false);
			// 			//   alert(err);
			// 			// }
			// 		} else if (response && response.id !== null) {
			// 			setInvoiceData([response]);
			// 			setInvoiceDialogOpen(true);
			// 		} else {
			// 			setSnackbarData({
			// 				open: true,
			// 				message: "Something went wrong.",
			// 				severity: "error",
			// 			});
			// 		}
			// 	} catch (err) {
			// 		
			// 		setIsPendingData(false);
			// 	}
			// }
		}
	};

	const onUnPaidClickHandler = (clickedRow: any, tag: string) => {
		setIsPendingData(true);
		const fetchData = async () => {
			try {
				const response: any =
					await ReportsService.paypalIntegrationOfUnpaidInvoice(
						clientId,
						clickedRow.refNo,
						tag
					);
				setIsPendingData(false);

				if (tag === "paypal") {
					window.open(response, "_blank");
				} else {
					window.open(response.message, "_blank");
				}
			} catch (error) {
				setIsPendingData(false);
				console.error("Error fetching data:", error);
			} finally {
				setIsPendingData(false);
			}
		};
		fetchData();
	};

	const onClickInvoiceNoHandler = (clickedRow: any) => {
		dispatch(setSelectedINVOICE(clickedRow));

	};
	/**
	 * On Snackbar closed.
	 *
	 * @param {React.SyntheticEvent | Event} event
	 * @param {string} reason
	 */
	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};
	// format date to 2023-07-26
	const formatDate = (date: Date): string => {
		return format(date, "yyyy-MM-dd"); // Format the date as "yyyy-MM-dd"
	};

	const onDateOfBirthChangeHandler = (selectedDate: any) => {

		if (selectedDate.value) {

			// alert(formatDate(selectedDate.value as Date));
			setDateOfBirth(formatDate(selectedDate.value as Date));
		} else {
			setDateOfBirth("");
		}
	};

	const onResourceSelectionChangeHandler = async (
		selectedItem: IEnhancedDropDownItem | any
	): Promise<void> => {
		formMethods.reset();
		setOnResourceSelectionAPIsCalls(true);
		// (async () => {
		// 	try {
		// 		setIsPendingSlipData(true);
		// 		let resourceDataById = await RL1SlipService.getResourceInformationById(
		// 			selectedItem.value,
		// 			clientId,
		// 			"Employee"
		// 		);

		// 		if (resourceDataById) {
		// 			Object.keys(resourceDataById).forEach((fieldName) => {
		// 				const fieldValue = resourceDataById[fieldName];
		// 				formMethods.setValue(
		// 					fieldName,
		// 					fieldValue !== null && fieldValue !== "" ? fieldValue : ""
		// 				);
		// 				if (fieldName === "id") {
		// 					formMethods.setValue("selectedEmployee", fieldValue);
		// 					(async () => {
		// 						try {
		// 							const response: any =
		// 								await RL1SlipService.getResourceSlipDropDownList(
		// 									fieldValue,
		// 									clientId,
		// 									taxYear
		// 								);
		// 							if (response && Array.isArray(response)) {
		// 								let resourceSlipList: IDropDownListResponse[] =
		// 									response.map((resourceSlip: IDropDownListResponse) => ({
		// 										label: resourceSlip.label,
		// 										value: resourceSlip.value,
		// 									}));

		// 								resourceSlipList.unshift({
		// 									label: "Create New",
		// 									value: "create-new",
		// 								});


		// 								setSelectedResourceSlipList(resourceSlipList);
		// 								if (resourceSlipList && resourceSlipList.length > 1) {
		// 									(async () => {
		// 										try {

		// 											setIsPendingSlipData(true);
		// 											let slipDataById =
		// 												await RL1SlipService.getRL1SlipById(
		// 													String(resourceSlipList[1].value),
		// 													clientId,
		// 													taxYear
		// 												);
		// 											setRL1SlipRecord(slipDataById);
		// 											setSelectedResourceSlip(
		// 												String(resourceSlipList[1].value)
		// 											);
		// 											formMethods.setValue(
		// 												"selectedSlip",
		// 												String(resourceSlipList[1].value)
		// 											);

		// 											slipDataByIdPass(slipDataById, true);
		// 											selectedRL1SlipType =
		// 												formMethods.getValues("slipType");
		// 											setSelectedOtherInformation(false);
		// 										} catch (error) {
		// 											setIsPendingSlipData(false);
		// 											console.error("Error fetching data:", error);
		// 										} finally {
		// 											setIsPendingSlipData(false);
		// 										}
		// 									})();
		// 								} else {
		// 									resourceDataByIdPass(resourceDataById);
		// 									setSelectedResource(String(selectedItem.value));
		// 									setEditedResourceId(String(selectedItem.value));
		// 									let path = `/compliance/rl1/setup/${selectedItem.value}`;
		// 									navigate(path);
		// 									setIsPendingSlipData(false);
		// 								}
		// 							}
		// 						} catch (error) {
		// 							console.error("Error fetching data:", error);
		// 						}
		// 					})();
		// 					setSelectedResource(fieldValue);
		// 				}
		// 			});
		// 		}
		// 	} catch (error) {
		// 		setIsPendingSlipData(false);
		// 		console.error("Error fetching data:", error);
		// 	}
		// })();

		let selectedEmployee = selectedItem

		setSelectedEmployee(String(selectedEmployee.value));
		setSelectedResource(String(selectedItem.value));
		if (selectedEmployee.totalSlips && Array.isArray(selectedEmployee.totalSlips)) {
			setIsPendingSlipData(true)
			let resourceSlipList: any[] =
				selectedEmployee.totalSlips.map((resourceSlip: any) => ({
					label: resourceSlip.label,
					value: resourceSlip.value,
					totalSlips: resourceSlip.totalSlips,
					slipType: resourceSlip.slipType
				}));

			resourceSlipList.unshift({
				label: "Create New",
				value: "create-new",
			});



			setSelectedResourceSlipList(resourceSlipList);

			if (resourceSlipList && resourceSlipList.length > 1) {
				setProvinceOfEmploymentId(String(resourceSlipList[1].value));
				setSelectedResourceSlip(
					String(resourceSlipList[1].value)
				);
				formMethods.setValue(
					"selectedSlip",
					String(resourceSlipList[1].value)
				);
				selectedRL1SlipType = formMethods.getValues("slipType");
				setSelectedOtherInformation(false);
				dispatch(setSelectedSlips({ rl1: { employeeId: selectedItem.value, provinceId: resourceSlipList[1].value, slipType: resourceSlipList[1].slipType } }));
				// (async () => {
				// 	try {
				// 		// let slipDataById = await RL1SlipService.getRL1SlipById(
				// 		// 	String(resourceSlipList[1].value),
				// 		// 	clientId,
				// 		// 	taxYear
				// 		// );
				// 		let slipDataById = await RL1SlipService.getRL1SlipByIdAndPoeIdAndSlipType(
				// 			selectedItem.value,
				// 			String(resourceSlipList[1].value),
				// 			resourceSlipList[1].slipType,
				// 			clientId,
				// 			taxYear
				// 		);
				// 		setRL1SlipRecord(slipDataById);
				// 		setSelectedResourceSlip(
				// 			String(resourceSlipList[1].value)
				// 		);
				// 		formMethods.setValue(
				// 			"selectedSlip",
				// 			String(resourceSlipList[1].value)
				// 		);
				// 		slipDataByIdPass(slipDataById, true);
				// 		selectedRL1SlipType = formMethods.getValues("slipType");
				// 		setSelectedOtherInformation(false);
				// 	} catch { }
				// })();
			} else {
				(async () => {
					try {
						setIsPendingSlipData(true);
						let resourceDataById = await RL1SlipService.getResourceInformationById(
							selectedItem.value,
							clientId,
							"Employee"
						);
						resourceDataByIdPass(resourceDataById);
					} catch { }
				})();
				// setSelectedEmployee('create-new')
				setSelectedResource(String(selectedItem.value));
				setEditedResourceId(String(selectedItem.value));
				let path = `/compliance/rl1/setup/${selectedItem.value}`;
				navigate(path);
				setIsPendingSlipData(false);
			}
		}
		setSelectedOtherInformation(false);
	};

	const onResourceSlipSelectionChangeHandler = (
		selectedItem: IEnhancedDropDownItem | any
	) => {
		setOnResourceSelectionAPIsCalls(true);
		setSelectedResourceSlip(String(selectedItem.value));
		if (selectedItem.value === "create-new") {
			setProvinceOfEmploymentId(null);
			setNotStartedSlipId("")
			dispatch(setSelectedSlips({ t4: { employeeId: selectedEmployee, provinceId: null, slipType: null } }));
			setRL1SlipRecord(undefined);
			createNewActionFromSlipDDL();
			setSelectedResourceSlip("create-new");
			if (selectedResource !== "create-new") {
				setOnResourceSelectionAPIsCalls(false);
				let path = `/compliance/rl1/setup/${selectedResource}`;
				navigate(path);
			}
		}
		if (selectedItem.value !== "create-new") {
			dispatch(setSelectedSlips({ t4: { employeeId: selectedEmployee, provinceId: selectedItem.value, slipType: selectedItem.slipType } }));
			(async () => {
				try {
					setIsPendingSlipData(true);
					// let slipDataById = await RL1SlipService.getRL1SlipById(
					// 	String(selectedItem.value),
					// 	clientId,
					// 	taxYear
					// );
					let slipDataById = await RL1SlipService.getRL1SlipByIdAndPoeIdAndSlipType(
						selectedEmployee,
						selectedItem.value,
						selectedItem.slipType,
						clientId,
						taxYear
					);
					setRL1SlipRecord(slipDataById);

					slipDataByIdPass(slipDataById, true);
					selectedRL1SlipType = formMethods.getValues("slipType");
					setSelectedOtherInformation(false);
					setIsPendingSlipData(false);
				} catch (error) {
					setIsPendingSlipData(false);
				}
			})();
		}
		setSelectedOtherInformation(true);
	};

	// for edit
	useEffect(() => {
		if (RL1SlipRecord && onResourceSelectionAPIsCalls === false) {
			slipDataByIdPass(RL1SlipRecord, onResourceSelectionAPIsCalls);
			setIsPendingSlipData(false);
		}
		selectedRL1SlipType = formMethods.getValues("slipType");
		setSelectedOtherInformation(false);
	}, [
		RL1SlipRecord,
		formMethods.setValue,
		formMethods,
		onResourceSelectionAPIsCalls,
	]);

	//this is for not started slip
	useEffect(() => {
		// if the selected flex field data has loaded.
		if (
			selectedNotStartedResourceData &&
			onResourceSelectionAPIsCalls === false
		) {
			resourceDataByIdPass(selectedNotStartedResourceData);
			setIsPendingSlipData(false);
		}
	}, [
		selectedNotStartedResourceData,
		formMethods.setValue,
		formMethods,
		onResourceSelectionAPIsCalls,
	]);

	// when  I formMethods.setValue of otherinformation inside async calls method then facing issue while click on add more so we have to use state method to show otherinformation
	useEffect(() => {

		if (
			slipOtherInformation &&
			slipOtherInformation !== null &&
			slipOtherInformation.length !== 0
		) {

			setOiInEdit(true);
			formMethods.setValue("comparison", slipOtherInformation);
		} else if (!id) {

			setOiInEdit(true);
			formMethods.setValue("comparison", [
				{
					amount: null,
					code: "",
					label: "",
				},
			]);
		}
	}, [slipOtherInformation]);

	const onSlipTypeSelectionChangeHandler = (e: any) => {
		setIsPendingSlipData(true);
		setTimeout(() => {
			setIsPendingSlipData(false);
		}, 1000);
		const selectedType = e.value;
		selectedRL1SlipType = selectedType;
		// alert(selectedType);
	};

	const onCloseHandler = () => {
		setDialogOpen(false);
		setInvoiceDialogOpen(false);
	};


	const tableScrollRef = useRef<HTMLDivElement>(null);
	const upadtedEmployeeDDLListItems = useMemo(() => {
		return (
			resourceListWithoutCreateNew &&
			resourceListWithoutCreateNew.map((item: any) => ({
				...item,
				label: (
					<span
						style={{ color: theme.palette.primary.light, cursor: "pointer" }}
						onClick={() => {
							onResourceSelectionChangeHandler(item)
							scrollPanelFieldsToTop();
						}}
					>
						{item.label}
					</span>
				),
			}))
		);
	}, [resourceListWithoutCreateNew]);

	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);

	const expandedLabels = ["Compliance", "RL-1"];
	const expandedRL1SetupItem = "Setup";
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (parentLabel === "RL-1" && item.label === expandedRL1SetupItem) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: parentLabel === "RL-1" && item.label === expandedRL1SetupItem && "/compliance/rl1/setup",
			};
			return enhancedItem;
		});
	};

	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: id ? id : "",
				entityId2: "",
				entityId3: "",
				screenName: RL1_SETUP_SCREEN_SLUG,
				companyName: clientName,
				activityType:
					"activity_type=create&activity_type=updated&activity_type=print&activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: true }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	return (
		<>
			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<BackdropCircularProgress
					open={
						isPendingEmployeeDDLItems ||
						isSubmitting ||
						isPendingData ||
						isPendingSlipData ||
						isPendingNotStartedSlipId ||
						isDeleting ||
						isPendingNotStartedSlipId ||
						isPendingDataa ||
						// isPendingGlobalVariables ||
						isPendingActivityLogData || isPendingPayFrequencyDDL
					}
					testId={testId}
				/>
				<DeleteConfirmationDialog
					open={openDialog}
					deleteActionHandler={deleteRL1SlipField}
					cancelActionHandler={onCloseHandler}
					testId="RL-1-confirmation-dialog"
				/>
				<FormProvider {...formMethods}>
					<form onSubmit={formMethods.handleSubmit(onSubmit)}>
						<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
							<Grid
								size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}
								sx={{
									borderRadius: "3px",
								}}
							>
								<TwoColumnLayout
									toolbar={
										<RL1SlipSetupToolbar
											onResetClicked={onResetClicked}
											onDeleteClicked={onDeleteClicked}
											onPrintClicked={onPrintClicked}
											isSubmitting={false}
											formMethods={formMethods}
											rl1SummaryData={rl1SummaryData && rl1SummaryData}
											pageTitle="RL-1 Setup"
											id={id}
										/>
									}
									leftColumnContent={
										<>
											<StandardPanel
												title="Slip Data"
												testId={`${testId}-slip-data`}
												// topPadding={!sidePanelsVisibility ? 2 : 0}
												borderHide={true}
											>
												{RL1OtherInformationList && (
													<T4SlipDataPanel
														formMethods={formMethods}
														isLoading={false}
														otherInformationList={
															RL1OtherInformationList !== undefined
																? RL1OtherInformationList
																: []
														}
														testId={testId}
														oiInEdit={oiInEdit}
														selectedOtherInformation={selectedOtherInformation}
													// globalVariablesData={
													// 	globalVariablesData && globalVariablesData
													// }
													/>
												)}
											</StandardPanel>
										</>
									}
									rightColumnContent={
										<>
											<StandardPanel
												title="Employee Info"
												testId={`${testId}-employee-info`}
												borderHide={true}
												borderBottom={true}
											>
												<EmployeeInfoSetupFieldsPanel
													onDateOfBirthChangeHandler={
														onDateOfBirthChangeHandler
													}
													testId={testId}
												/>
											</StandardPanel>
											<StandardPanel
												title="Address"
												testId={`${testId}-employee-address-panel`}
												borderHide={true}
												borderBottom={true}
											>
												<EmployeeAddressSetupFieldsPanel
													testId={testId}
													countryList={countryList}
													formMethods={formMethods}
													provinceDDLLoading={(value: boolean) =>
														setProvinceDDLLoading(value)
													}
													provinceStateLabelinUpdate={
														provinceStateLabelinUpdate &&
														provinceStateLabelinUpdate
													}
													provinceStateDDLinUpdate={
														provinceStateDDLinUpdate && provinceStateDDLinUpdate
													}
													provinceDDLItems={(value: any) =>
														setProvinceDDLItems(value)
													}
													cityDDLinUpdate={cityDDLinUpdate && sortDDLByLabel(cityDDLinUpdate)}
													isAdminUser={isAdminUser}
												/>
											</StandardPanel>
											<StandardPanel
												title="Filing Data"
												testId={`${testId}-filing-data-panel`}
												borderHide={true}
											>
												<EnhancedDropDownRHFWithLabel
													label="Slip Type"
													selectName="slipType"
													items={[
														{ label: "Original", value: 400 },
														{ label: "Amended", value: 200 },
														{ label: "Cancelled", value: 300 },
														{ label: "Additional", value: 100 },
													]}
													selectedItem={400}
													testId="slip-type"
													labelPosition={LabelPosition.Top}
													required
													onSelectionChangeHandler={
														onSlipTypeSelectionChangeHandler
													}
												/>

												<FilingDataSetupFieldsPanel
													testId={testId}
													formMethods={formMethods}
													payFrequencyDDLItems={
														payFrequencyDDLItems && sortDDLByLabel(payFrequencyDDLItems)
													}
												/>
											</StandardPanel>
										</>
									}
									testId="rl1-slip-setup-form"
								/>
							</Grid>
							<Grid size={{ xs: 0, sm: 0, md: 1, lg: 1, xl: 1 }}></Grid>
							<Grid
								size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
								sx={{ marginTop: "16px" }}
							>
								<ResourceDDLDataTableForSlips
									rows={
										employeeDDLItems && upadtedEmployeeDDLListItems
											? upadtedEmployeeDDLListItems
											: []
									}
									selectedEmployee={selectedEmployee}
									selectedResourceSlipList={selectedResourceSlipList}
									selectedResourceSlip={selectedResourceSlip}
									onResourceSlipSelectionChangeHandler={
										onResourceSlipSelectionChangeHandler
									}
									tableScrollHeight={"60vh"}
									// selectedId={RL1SlipRecord && id && RL1SlipRecord?.resource?.externalId}
									selectedId={selectedEmployee}
									tableContainerRef={tableScrollRef}
								/>
							</Grid>
							<Grid size={{ xs: 0, sm: 0, md: 0, lg: 1, xl: 1 }}></Grid>
						</Grid>
					</form>
				</FormProvider>
				{/* invoice dialogu open if any transaction is unPaid */}
				<EnhancedDialog
					dialogTitle="Invoice(s) Due"
					key="dialog-box"
					testId="dialog"
					onCloseHandler={onCloseHandler}
					open={openInvoiceDialog}
					dialogContent={
						<InvoiceDialogPanel
							invoiceData={invoiceData}
							onUnPaidClickHandler={onUnPaidClickHandler}
							onClickInvoiceNoHandler={onClickInvoiceNoHandler}
						/>
					}
					dialogAction={
						<Grid>
							<Button autoFocus variant="contained" onClick={onCloseHandler}>
								Cancel
							</Button>
						</Grid>
					}
				/>
				<EnhancedSnackbar
					message={snackbarData.message}
					onCloseHandler={onSnackbarClosed}
					severity={snackbarData.severity}
					testId={`${testId}-snackbar`}
					open={snackbarData.open}
					autoHide={snackbarData.autoHide}
				/>
			</Grid>
		</>
	);
};
